import { FunctionComponent, PropsWithChildren, useEffect } from "react";
import { useUserContext } from "../../user/contexts/user.context";
import { Route, RouteProps } from "react-router-dom";

export const RequireAuthGuard: FunctionComponent<PropsWithChildren<unknown> & RouteProps> = ({
  children,
  ...routeProps
}) => {
  const { hasUser, getMyself } = useUserContext();

  useEffect(() => {
    hasUser || getMyself();
  }, [hasUser, getMyself]);

  return <Route {...routeProps} render={() => (hasUser ? children : null)} />;
};
